$(document).ready(function () {

    window.defaultNav = $('#mainNavigation').clone();
    let nx = 0;

    function customNavStructure() {

        if (nx === 1) {
            return false;

        } else if (nx === 0) {

            // Navigation links

            function createOuterColumns() {
                $('#mainNavigation .mainNavigationItem1 .navClonedItem').remove();
                let firstNavGroupItems = $('#mainNavigation .mainNavigationItem1 > .items > .item');
                firstNavGroupItems.splice(0, 3);
                firstNavGroupItems.wrapAll('<li class="normal-col"></li>');
                $('#mainNavigation .mainNavigationItem1 .normal-col > li').wrapAll('<ul class="subitems"></ul>');
            }

            createOuterColumns()

            function createColumns(items, itemsWrapper) {
                let itemAmount = items.length;

                function columnWrap(perCol) {
                    if (itemAmount > perCol) {
                        for (let i = 0; i < itemAmount; i += perCol) {
                            items.slice(i, i + perCol).wrapAll('<ul class="multi-columns__column"></ul>');
                        }
                        itemsWrapper.attr('style', 'width:' + 225 * itemsWrapper.find('.multi-columns__column').length + 'px');
                        itemsWrapper.addClass('multi-columns');
                        itemsWrapper.parent('.item').css('width', 'auto');
                        itemsWrapper.parent('.item').addClass('has-multi-columns');
                    }
                }

                if (itemAmount <= 16) {
                    columnWrap(8);
                } else {
                    columnWrap(12);
                }
            }

            let innerColumnsItems = $('#mainNavigation .mainNavigationItem1 > .items > .item:nth-child(2) > .subitems > .item');
            let innerColumnsItemsWrapper = $('#mainNavigation .mainNavigationItem1 > .items > .item:nth-child(2) > .subitems');

            createColumns(innerColumnsItems, innerColumnsItemsWrapper);

            window.megaNav = $('#mainNavigation').clone();
            nx = 2;
        }
    }

    function handleNav() {
        if ($('body').hasClass('saffireLargeSize')) {
            if (nx === 2) {
                $('#mainNavigation').replaceWith(window.megaNav);
                $('body').addClass('megaNav');
            } else {
                nx = 0;
                customNavStructure();
                $('body').addClass('megaNav');
            }
        }
        if ($('body').hasClass('saffireMobileSize')) {
            nx = 1;
        }
    }

    $(window).load(function () {
        handleNav();
    });

    $(window).resize(function () {
        if ($('body').hasClass('saffireLargeSize')) {
            if (!$('body').hasClass('megaNav')) {
                handleNav();
            }
        }
        if ($('body').hasClass('saffireMobileSize')) {
            if ($('body').hasClass('megaNav')) {
                $('#mainNavigation').replaceWith(window.defaultNav);
                $('body').removeClass('megaNav');
            }
        }
    });

});



